export default __webpack_public_path__ + "static/media/IT-1.ba578f99.png";